import type { ApolloError } from 'apollo-client';

import { usePageRestrictionsContext } from '@confluence/page-restrictions-context/entry-points/PageRestrictionsContext';
import { expVal } from '@confluence/feature-experiments';

type PageViewRestrictionsProps = {
	children: (result: {
		error?: ApolloError | undefined;
		hasDirectViewRestrictions: boolean | undefined;
		hasInheritedViewRestrictions: boolean | undefined;
		loading?: boolean;
	}) => JSX.Element | null;
};

export function PageViewRestrictions({ children }: PageViewRestrictionsProps) {
	const { restrictions, error, loading } = usePageRestrictionsContext();

	if (expVal('confluence_restrictions_fix', 'isEnabled', false)) {
		const hasDirectViewRestrictions = Boolean(restrictions?.hasViewRestrictions);
		const hasInheritedViewRestrictions = Boolean(restrictions?.hasInheritedRestrictions);
		if (loading) {
			return null;
		}
		return children({
			error,
			hasDirectViewRestrictions,
			hasInheritedViewRestrictions,
		});
	} else {
		let hasDirectViewRestrictions: boolean | undefined;
		let hasInheritedViewRestrictions: boolean | undefined;

		if (!loading) {
			hasDirectViewRestrictions = Boolean(restrictions?.hasViewRestrictions);
			hasInheritedViewRestrictions = Boolean(restrictions?.hasInheritedRestrictions);
		}

		return children({
			error,
			hasDirectViewRestrictions,
			hasInheritedViewRestrictions,
			loading,
		});
	}
}
